import React from "react"
import { useTranslation } from "react-i18next"

import { DialogTitle } from "@/nzds/feedback/dialog-title/dialog-title"

import { Box, Dialog, Typography } from "@mui/material"
import { visuallyHidden } from "@mui/utils"

const pdfViewerPaperSx = {
  bgcolor: "grey.800",
} as const

const pdfViewerTitleSx = {
  color: "common.white",
  "& .MuiIconButton-root": {
    color: "common.white",
  },
} as const

interface BillPdfViewerDialogProps {
  downloadUrl: string
  iframeTitle: string
  onClose: () => void
  open: boolean
  title: string
}

export const BillPdfViewerDialog: React.FC<BillPdfViewerDialogProps> = ({
  downloadUrl,
  iframeTitle,
  onClose,
  open,
  title,
}) => {
  const { t } = useTranslation("common")
  const dialogTitle = title.trim()

  return (
    <Dialog
      aria-describedby="bill-pdf-viewer-load-error"
      aria-labelledby="bill-pdf-viewer-title"
      data-testid="bill-pdf-viewer-dialog"
      fullScreen
      onClose={onClose}
      open={open}
      slotProps={{
        paper: {
          sx: pdfViewerPaperSx,
        },
      }}
    >
      <DialogTitle
        id="bill-pdf-viewer-title"
        onClose={onClose}
        sx={pdfViewerTitleSx}
      >
        <Typography color="inherit" variant="h3">
          {dialogTitle}
        </Typography>
      </DialogTitle>
      <Typography
        color="common.white"
        id="bill-pdf-viewer-load-error"
        role="status"
        sx={visuallyHidden}
        variant="body2"
      >
        {t("billPdfViewerLoadError")}
      </Typography>
      {open ? (
        <Box
          component="iframe"
          src={downloadUrl}
          sx={{ border: 0, flex: 1, width: "100%" }}
          title={iframeTitle}
        />
      ) : null}
    </Dialog>
  )
}
